import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LaasComponent } from "./laas.component";
// import { CkycFormComponent } from './loan/app-forms/ckyc-form/ckyc-form.component';
import { AdminAuthGuard } from "app/admin/admin-auth-guard.service";
// import { BhoomiRtcComponent } from './bhoomi-rtc/bhoomi-rtc.component';
import { ConsentFormComponent } from "./consent-form/consent-form.component";
import { GeoMappingComponent } from "./geo-mapping/geo-mapping.component";
import { LaasCbsAuthGuard } from "./laas-auth-guard.service";
import { LandRecordsMpComponent } from "./land-records-mp/land-records-mp.component";
import { FruitsLandRecordComponent } from "./fruits-land-record/fruits-land-record.component";
import { LandRecordUpdateNewComponent } from "./land-record-update-new/land-record-update-new.component";
import { LandRecordsApComponent } from "./land-records-ap/land-records-ap.component";
import { ProfileComponent } from "./dashboard/profile/profile.component";
import { LoanRenewalFormComponent } from "./loan/shared/loan-renewal-form/loan-renewal-form.component";
import { CrifReportViewComponent } from "./financial/cibil-report/cibil-report-view/crif-report-view.component";
import { CrifReportComponent } from "./financial/cibil-report/cibil-report.component";
import { BreStatusCheckComponent } from "./financial/bre-status/brestatuscheck.component";

const routes: Routes = [
  {
    path: "",
    component: LaasComponent,
    children: [
      {
        path: "loan-renewal-form",
        component: LoanRenewalFormComponent,
        canActivate: [AdminAuthGuard],
      },
      {
        path:'bre-status',
        component:BreStatusCheckComponent,
        canActivate: [AdminAuthGuard, LaasCbsAuthGuard]
      },
      {
        path: "creditview",
        component: CrifReportComponent,
        canActivate: [AdminAuthGuard, LaasCbsAuthGuard],
      },
      // { path: 'identity', loadChildren: './identity/identity.module#IdentityModule', canActivate: [AdminAuthGuard, LaasCbsAuthGuard] },
      {
        path: "dashboard",
        component: ProfileComponent,
        canActivate: [AdminAuthGuard, LaasCbsAuthGuard],
      },
      // { path: 'bhoomi-rtc', component: BhoomiRtcComponent, canActivate: [AdminAuthGuard, LaasCbsAuthGuard]},
      // { path: 'bhoomi', loadChildren: './bhoomi/bhoomi.module#BhoomiModule'},

      {
        path: "consent-form",
        component: ConsentFormComponent,
        canActivate: [AdminAuthGuard, LaasCbsAuthGuard],
      },
      {
        path: "geo-mapping",
        component: GeoMappingComponent,
        canActivate: [AdminAuthGuard, LaasCbsAuthGuard],
      },
      { path: "land-records-mp", component: LandRecordsMpComponent },
      //  { path: 'land-records-ap', component: LandRecordsApComponent },
      { path: "land-records-ka", component: FruitsLandRecordComponent },
      {
        path: "land-record-update",
        component: LandRecordUpdateNewComponent,
        canActivate: [AdminAuthGuard, LaasCbsAuthGuard],
      },
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
        canActivate: [AdminAuthGuard, LaasCbsAuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LaasRoutingModule {}
